export interface GoogleTagManagerConstants {
  VITE_GTM_ID: string;
  NO_VALUE: string;
}

const GoogleTagManager: GoogleTagManagerConstants = {
  VITE_GTM_ID: "VITE_GTM_ID",
  NO_VALUE: "NO_VALUE",
};

export default GoogleTagManager;
